// UploadFastaService.ts

import type { IFastaRepository } from "@domain/repositories";
import { PagedFastaFileList } from "@domain/schemas/BI";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";

@injectable()
class ListFastaService {
  @inject(TYPES.IFastaRepository)
  private _fastaRepository!: IFastaRepository;

  async listFastaAsync(projectId: string, sourcePath?: string | null, folder?: string | null): Promise<PagedFastaFileList> {
    return this._fastaRepository.getListAsync(projectId, sourcePath, folder);
  }
}

export { ListFastaService };
